import React, { useRef, useState, useEffect } from "react";
import Sidebar from "../sidebar/sidebar";
import Layout from "../layout/layout";
import style from "./style.module.css";
import { FaCloudArrowUp } from "react-icons/fa6";
import TabsComponent, { Tab } from "../tabs/Tabs";
import InputText from "../inputText/InputText";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UploadMovie, urlUpload } from "../../api/HttpApis";
import Loader from "../../utils/loader/Loader";
import Button from "../button/Button";
import { showToast} from "../../utils/Toastify/Toastify";

const CommonFileUpload = () => {
  const fileInputRef = useRef();
  // const [selectedFile, setSelectedFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const seriesId = params.seriesId || location.state?.seriesId;
  const seasonId = params.seasonId || location.state?.seasonId;
  const nextEpisodeNumber = params.nextEpisodeNumber || location.state?.nextEpisodeNumber;
  const name = location.state?.name || "";



  // Cleanup object URL when videoUrl changes or component unmounts
  useEffect(() => {
    return () => {
      if (videoUrl) {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, [videoUrl]);

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };

  const handleNext = async () => {
    if (!url.trim()) {
      showToast("Please enter a valid URL", "error");
      return;
    }

    const formData = new FormData();
    formData.append("video_url", url.trim());

    try {
      setLoading(true);
      const response = await urlUpload(formData);
      const videoId = response?.data?.data?.video_id;
      setLoading(false);

      if (videoId) {
        let path = `/video/${videoId}`;
        const hasSeriesData = seriesId && seasonId && nextEpisodeNumber;

        if (hasSeriesData) {
          path += `/${seriesId}/${seasonId}/${nextEpisodeNumber}`;
        } else {
          console.warn("Some series metadata is missing. Routing to base video path.");
        }

        navigate(path, {
          state: {
            movieId: videoId,
            name,
            ...(hasSeriesData && { seriesId, seasonId, nextEpisodeNumber }),
          },
        });
      } else {
        showToast("Invalid response from server", "error");
      }
    } catch (error) {
      setLoading(false);
      showToast(error?.response?.data?.message || "URL upload failed", "error");
    }
  };


  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // setSelectedFile(file);
    setVideoUrl(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append("video", file);

    try {
      setLoading(true);
      const response = await UploadMovie(formData);
      const videoId = response?.data?.data?.video_id;
      setLoading(false);

      if (videoId) {
        let path = `/video/${videoId}`;
        const hasSeriesData = seriesId && seasonId && nextEpisodeNumber;

        if (hasSeriesData) {
          path += `/${seriesId}/${seasonId}/${nextEpisodeNumber}`;
        } else {
          console.warn("Some series metadata is missing. Routing to base video path.");
        }

        navigate(path, {
          state: {
            movieId: videoId,
            name,
            ...(hasSeriesData && { seriesId, seasonId, nextEpisodeNumber }),
          },
        });
      } else {
        showToast("Invalid response from server", "error");
      }
    } catch (error) {
      setLoading(false);
      showToast(error?.response?.data?.message || "File upload failed", "error");
    }
  };


  return (
    <>
      <div className={style.mainContainer}>
        <Sidebar seriesId={seriesId} seasonId={seasonId} />

        <Layout>
          <div className={style.mainBox}>
            <TabsComponent>
              <Tab name="File Upload">
                <div className={style.bannerBox}>
                  <div className={style.bannerInputField}>
                    <input
                      type="file"
                      accept="video/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      aria-label="Upload video file"
                    />
                    {loading ? (
                      <>
                        <Loader />
                        <div className={style.uploadText}>
                          Video Uploading...
                        </div>
                      </>
                    ) : !videoUrl ? (
                      <button
                        onClick={handleIconClick}
                        className={style.uploadButton}
                        aria-label="Upload video from computer"
                      >
                        <div>
                          <FaCloudArrowUp className={style.cloudIcon} />
                        </div>
                        <div>
                          <p className={style.uploadText}>
                            Upload from Computer
                          </p>
                          <p className={style.paraText}>
                            Drag & Drop your file or click to browse
                          </p>
                        </div>
                      </button>
                    ) : null}
                  </div>
                </div>
              </Tab>

              <Tab name="URL">
                <div className={style.bannerBox}>
                  {loading ? (
                    <>
                      <Loader />
                      <div className={style.uploadText}>URL Uploading...</div>
                    </>
                  ) : (
                    <div className={style.urlBox}>
                      <h3>Enter a URL</h3>
                      <InputText
                        type="text"
                        value={url}
                        placeholder="https://example.com/video.mp4"
                        onChange={handleUrlChange}
                        variant="modal"
                        aria-label="Video URL input"
                      />
                      <Button
                        onClick={handleNext}
                        disabled={loading || !url.trim()}
                      >
                        Next
                      </Button>
                    </div>
                  )}
                </div>
              </Tab>
            </TabsComponent>
          </div>
        </Layout>
      </div>
    </>
  );
};

export default CommonFileUpload;
